namespace Ir.Components.Workbook.ToolBar.CreateWorkbookToolBar {
    interface ICreateWorkbookToolBarViewModel {
        buttonOptions: any;
        callback: Function;
        onMappingClick: (id: number, name: string) => void;
    }

    export function getViewModel(this: ICreateWorkbookToolBarViewModel, params: any) {

        let showPopover;
        this.callback = function (obj) {
            showPopover = obj.show;
        }

        this.buttonOptions = {
            hint: 'Create a new Workbook',
            template: `<i class="ms ms-white ms-bold">add</i><i class="ms">import_contacts</i>`,
            stylingMode: 'contained',
            type: params?.buttonType ?? "success",
            height: params?.height,
            width: 40,
            onClick(e) {
                showPopover(e.element);
            },
            visible: ko.computed(function () { return loggedUser.permissions.createWorkbooks(); })
        }

        this.onMappingClick = function (this: ICreateWorkbookToolBarViewModel, id: number, name: string) {
            let url = `${urlConfigs.tabs}new/${id}`;
            workbook.workbookConfig.workbookHelper.goToURL(url, name);
        }.bind(this);
    }
}